export enum Roles {
  accountManager = 'accountmanager',
  administrator = 'administrator',
  projectManager = 'projectmanager',
  coach = 'coach',
  salesManager = 'salesmanager',
  agent = 'agent',
  manager = 'manager',
}
